/*
 * @Author: your name
 * @Date: 2022-05-10 11:05:59
 * @LastEditTime: 2023-02-24 11:19:24
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-05-12 13:39:47
 * @LastEditors: Dong
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/services/serviceManage.ts
 */

import request from 'root/utils/request';

const basePath = '/api/ops-manager/v1/supos/service';

// 查询服务列表
export const queryList = async (param: Object) => {
  return request.get(`${basePath}/list`, {
    params: { ...param },
  });
};

// 获取所有命名空间
export const getNamespace = async () => {
  return request.get(`${basePath}/namespace/list`);
};

// 停止服务
export const stopServices = async (namespace: string, params: any) => {
  return request.post(`${basePath}/namespace/${namespace}/stop`, params);
};

// 重启服务
export const reStartServices = async (namespace: string, params: any) => {
  return request.post(`${basePath}/namespace/${namespace}/restart`, params);
};

// 启动服务
export const startServices = async (namespace: string, params: any) => {
  return request.post(`${basePath}/namespace/${namespace}/start`, params);
};

// 获取资源配置
export const getSourceConfig = async (params: any) => {
  return request.get(`${basePath}/resource`, {
    params: { ...params },
  });
};

// 更新资源配置
export const saveSourceConfig = async (params: any) => {
  return request.put(`${basePath}/resource`, params);
};

// 获取所属应用列表（select的选择项）
export const getApplicationList = async () => {
  return request.get(`/api/ops-manager/v1/system/application/names`);
};

// 获取系统应用管理列表
export const getSystemApplicationList = async (params: any) => {
  return request.get(`/api/ops-manager/v1/system/application/list`, { params: { ...params } });
};

// 获取应用对应的pod列表
export const getPods = async (params: any) => {
  return request.get(`/api/ops-manager/v1/system/application/pods`, { params: { ...params } });
};

// 获取属于领域列表（select的选择项）
export const getDomainList = async () => {
  return request.get(`/api/ops-manager/v1/system/application/domains`);
};

// 获取查看日志弹窗左侧树结构
export const getLogTree = async (serviceName: string) => {
  return request.get(`/api/ops-manager/v1/supos/log/${serviceName}`);
};

// 下载单个日志
export const serverLogDownload = async (params: any) => {
  return request.post(`/api/ops-manager/v1/supos/log/download`, params, {
    responseType: 'blob',
  });
};

// 根据服务名获取pod列表
export const getPodList = async (serviceName: string) => {
  return request.get(`/api/ops-manager/v1/supos/log/pod/${serviceName}`);
};
